import { config } from 'src/utils/config';
import { getStandardHeaders, performFetchWithLogging } from '../utils/helpers';
import type { RunsListResponse, DryRunPayload } from 'src/types/Schedules';
import type { ScheduleRunSession } from 'src/chat/types';
import { FetchResult } from 'src/types/TApiQueries';

const PROXY_BASE = config.chatProxyUrl;

export async function getScheduleRuns(
  accessToken: string,
  scheduleId: string,
  limit = 50,
): Promise<FetchResult<RunsListResponse>> {
  return performFetchWithLogging<RunsListResponse>(
    `${PROXY_BASE}/api/v1/chat/ai/schedules/${scheduleId}/runs?limit=${limit}`,
    {
      method: 'GET',
      headers: getStandardHeaders(accessToken),
      credentials: 'include',
    },
  );
}

export async function getScheduleRunSession(
  accessToken: string,
  sessionId: string,
): Promise<FetchResult<ScheduleRunSession>> {
  return performFetchWithLogging<ScheduleRunSession>(
    `${PROXY_BASE}/api/v1/chat/sessions/${sessionId}`,
    {
      method: 'GET',
      headers: getStandardHeaders(accessToken),
      credentials: 'include',
    },
  );
}

export function runScheduleNow(
  accessToken: string,
  scheduleId: string,
  signal?: AbortSignal,
): Promise<Response> {
  return fetch(`${PROXY_BASE}/api/v1/chat/ai/schedules/${scheduleId}/run`, {
    method: 'POST',
    headers: {
      Authorization: accessToken,
      Accept: 'text/event-stream',
    },
    signal,
  });
}

export function dryRunSchedule(
  accessToken: string,
  payload: DryRunPayload,
  signal?: AbortSignal,
): Promise<Response> {
  return fetch(`${PROXY_BASE}/api/v1/chat/ai/schedules/dry-run`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: accessToken,
      Accept: 'text/event-stream',
    },
    body: JSON.stringify(payload),
    signal,
  });
}
